export default __webpack_public_path__ + "static/media/elmar.ecd4349b.png";